import React, { Component } from "react";
import { Link } from "react-router-dom";
import penyelenggara from "../assets/penyelenggara-sertifikat-elektronik.png";
import logoKominfo from "../assets/logo-kominfo-white.svg";
import CallIcon from "../assets/calling.svg";
import TeleIcon from "../assets/telegram.svg";

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      form: {
        name: "",
        email: "",
        subject: "",
        body: "",
      },
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  render() {
    let { width } = this.state;

    return (
      <section className="footer" id="footer">
        <div style={{ backgroundColor: "#1672BD" }}>
          <div
            className="container"
            style={
              width < 728
                ? {
                    padding: "30px 0px",
                  }
                : {
                    padding: "30px 0px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }
            }
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: width >= 728 ? "flex-start" : "center",
                marginBottom: width >= 728 ? 0 : 20,
              }}
            >
              <img
                className="mb-0"
                src={logoKominfo}
                alt="kominfo"
                style={{
                  height: "55px",
                  objectFit: "contain",
                  marginRight: 20,
                }}
              />
              <div>
                <p
                  className="p-nunito"
                  style={{ marginBottom: 0, color: "white" }}
                >
                  Direktorat Jenderal Pengawasan Ruang Digital
                </p>
                <p
                  className="p-nunito"
                  style={{ marginBottom: 0, color: "white" }}
                >
                  Jalan Medan Merdeka Barat 9 Jakarta Pusat
                </p>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: width >= 728 ? "flex-start" : "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#0B3F88",
                  padding: "8px 32px",
                  borderRadius: 19,
                  marginRight: 20,
                }}
              >
                <img
                  className="mb-0"
                  src={CallIcon}
                  alt="call"
                  style={{
                    height: "24px",
                    objectFit: "contain",
                    marginRight: 10,
                  }}
                />
                <p
                  className="p-nunito"
                  style={{ marginBottom: 0, color: "white" }}
                >
                  159 Ext. 3
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#0B3F88",
                  padding: "8px 32px",
                  borderRadius: 19,
                }}
              >
                <img
                  className="mb-0"
                  src={TeleIcon}
                  alt="mail"
                  style={{
                    height: "24px",
                    objectFit: "contain",
                    marginRight: 10,
                  }}
                />
                <p
                  className="p-nunito"
                  style={{ marginBottom: 0, color: "white" }}
                >
                  tte@komdigi.go.id
                </p>
              </div>
            </div>
          </div>
          {/* <div className="space-between" style={{ flexWrap: "wrap" }}></div> */}
        </div>
        <div style={{ backgroundColor: "#0B3F88" }}>
          <div
            className="container"
            style={{
              padding: "30px 0px",
              display: "flex",
              flexDirection: width >= 728 ? "row" : "column",
              // alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h6
                className="h6-nunito"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  margin: "42px 0px",
                }}
              >
                Sitemap website PSrE
              </h6>
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: 425,
                    padding: "14px 0px",
                  }}
                >
                  <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/"
                  >
                    Beranda
                  </a>
                  <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/event/blog"
                  >
                    Berita
                  </a>
                  <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/verifyPDF"
                  >
                    Verifikasi PDF
                  </a>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: 425,
                    padding: "14px 0px",
                  }}
                >
                  {/* <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/login"
                  >
                    Masuk
                  </a> */}
                  <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/apaitu"
                  >
                    Profile
                  </a>
                  {/* <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/event/all"
                  >
                    Acara & Webinar
                  </a> */}
                  <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/listpsrenew"
                  >
                    Daftar PSrE
                  </a>
                  <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/lembaga-sertifikat"
                  >
                    Lembaga Sertifikasi
                  </a>
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: 425,
                    padding: "14px 0px",
                  }}
                >
                  <a
                    style={{ flex: 1, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/signup"
                  >
                    Buat Akun
                  </a>
                  <a
                    style={{ flex: 2, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/listPSrE/_"
                  >
                    Daftar PSrE
                  </a>
                </div> */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: 425,
                    padding: "14px 0px",
                  }}
                >
                  <a
                    style={{ flex: 2, margin: 0, color: "white" }}
                    className="p-nunito"
                    href="/regulation"
                  >
                    Regulasi, Panduan & Infografik
                  </a>
                </div>
              </div>
            </div>
            <div>
              <h6
                className="h6-nunito"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  margin: "42px 0px",
                }}
              >
                Hubungi Kami
              </h6>
              <form
              // action="mailto:tte@komdigi.go.id?Subject=Tanya%20PSrE"
              // method="post"
              // enctype="text/plain"
              >
                <div>
                  <input
                    type="text"
                    name="Name"
                    placeholder="Nama Anda"
                    style={{
                      marginRight: 14,
                      borderRadius: 19,
                      padding: "6px 30px",
                      border: "0px",
                      marginBottom: 20,
                    }}
                    className="p-nunito"
                    onChange={({ target: { value } }) =>
                      this.setState({
                        form: { ...this.state.form, name: value },
                      })
                    }
                  />
                  <input
                    type="email"
                    name="Email"
                    placeholder="Alamat Email"
                    style={{
                      borderRadius: 19,
                      padding: "6px 30px",
                      border: "0px",
                      marginBottom: 20,
                    }}
                    className="p-nunito"
                    onChange={({ target: { value } }) =>
                      this.setState({
                        form: { ...this.state.form, email: value },
                      })
                    }
                  />
                </div>
                <input
                  type="text"
                  name="Institution"
                  placeholder="Institusi/ Perusahaan"
                  style={{
                    borderRadius: 19,
                    padding: "6px 30px",
                    border: "0px",
                    marginBottom: 20,
                    width: "100%",
                  }}
                  className="p-nunito"
                  onChange={({ target: { value } }) =>
                    this.setState({
                      form: { ...this.state.form, institution: value },
                    })
                  }
                />
                <textarea
                  placeholder="Tulis pesan disini ..."
                  name="pesan"
                  style={{
                    border: "none",
                    borderRadius: 19,
                    padding: "10px 30px",
                    width: "100%",
                    height: 110,
                  }}
                  className="p-nunito"
                  onChange={({ target: { value } }) =>
                    this.setState({ form: { ...this.state.form, body: value } })
                  }
                />
                <button
                  style={{
                    backgroundColor: "#1672BD",
                    display: "inline-block",
                    textAlign: "center",
                    padding: "10px 12px",
                    marginTop: 30,
                    borderRadius: 20,
                    cursor: "pointer",
                    borderColor: "#1672BD",
                  }}
                  onClick={() => {
                    window.open(
                      `mailto:tte@komdigi.go.id?subject=Tanya PSRE&body=${this.state.form.body}`,
                      "_blank"
                    );
                  }}
                >
                  <p style={{ margin: 0, color: "white" }} className="p-nunito">
                    Kirim Pesan Email
                  </p>
                </button>
              </form>
            </div>
          </div>
          <div style={{ height: 40 }} />
        </div>
        <div style={{ backgroundColor: "#1B0D4D" }}>
          <div
            className="container"
            style={{
              padding: "20px 0px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p
              style={{ marginBottom: 0, color: "#1672BD" }}
              className="p-nunito"
            >
              Copyrights (c) Direktorat Jenderal Pengawasan Ruang Digital | 2021
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Link
                style={{ marginBottom: 0, color: "#1672BD", marginRight: 30 }}
                className="p-nunito"
                to="/privacy"
              >
                Kebijakan Privasi
              </Link>
              <Link
                style={{ marginBottom: 0, color: "#1672BD" }}
                className="p-nunito"
                to="/tnc"
              >
                Ketentuan Layanan
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
